<template>
    <layout-main>
        <!-- CONTENT TO MOVE -->
        <div class="topbar">
            <div class="container">
                <table class="appointments">
                    <thead>
                        <th width="25%" class="text-left">Kategori</th>
                        <th width="15%">Dato</th>
                        <th width="15%">Start</th>
                        <th width="15%">Slut</th>
                        <th width="15%">Instruktør</th>
                        <th width="15%">
                            <router-link :to="{ name: 'appointments/calender' }" class="btnPlus">+</router-link>
                        </th>
                    </thead>
                </table>
            </div>
        </div>

        <div class="container">
            <appointments></appointments>
        </div>
        <!--  -->
    </layout-main>
</template>

<script>
import LayoutMain from '@/views/layouts/Main.vue';
import Appointments from '@/components/appointment/Appointments.vue';

export default {
    components: {
        'layout-main': LayoutMain,
        'appointments': Appointments,
    },
    methods: {
    }
}
</script>
